<template>
  <div>
    <div class="subheading grey--text mt-6 ml-3">
      <h5 v-if="receivedContacts">
        Contacts[{{ receivedContacts.totalRecords }}]
      </h5>
    </div>
    <div class="mx-2">
      <v-data-table
        v-if="receivedContacts"
        :headers="headers"
        :items="receivedContacts.contacts"
        item-key="name"
        hide-default-footer
        ><template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn
              class="primary white--text lowercase-text"
              plain
              @click="dialogs.create = true"
            >
              Add contact
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | niceDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <ContactMenu :contact="item" /> </template
      ></v-data-table>
      <div class="text-center mt-8">
        <Pagination
          v-if="receivedContacts"
          store="contacts"
          collection="contacts"
          action="fetchContacts"
        />
      </div>
    </div>
    <DialogCreate @close="dialogs.create = false" v-if="dialogs.create" />
  </div>
</template>
<script>
import { format } from "date-fns";
import DialogCreate from "./Dialogs/CreateContact";
import ContactMenu from "./menu/ContactTableMenu";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: { DialogCreate, ContactMenu, Pagination },
  data() {
    return {
      dialogs: {
        create: false,
      },
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Phone", value: "phone" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  created() {
    this.$store.dispatch("contacts/fetchContacts", 1);
  },
  computed: {
    receivedContacts() {
      return this.$store.getters["contacts/contacts"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
